export default "__VITE_ASSET__828d0675__"